export default __webpack_public_path__ + "static/media/thinh.c7503a18.jpg";